export { default as CourseSubChapter } from './CourseSubChapter';
